{
  "/aws-networking-consulting": "/aws-platform-consulting#networking",
  "/aws-networking": "/aws-platform-consulting#networking",
  "/aws-architecture-review": "/aws-platform-consulting#architecture",
  "/aws-cost-optimization": "/aws-platform-consulting#cost",
  "/aws-cost-review": "/aws-platform-consulting#cost",
  "/aws-migration-consulting": "/aws-platform-consulting#migrations",
  "/ecs-fargate-consulting": "/aws-platform-consulting#containers",
  "/observability-review": "/aws-observability-consulting"
}
